// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const getState = state => state.sltSlt3bUpgrade || fromJS({});

export const upgradeStartTime = createSelector(getState, state => state.get('sltSlt3bUpgradeStartTime'));
export const isUpgrading = createSelector(getState, state => state.get('sltSlt3bUpgradeIsUpgrading'));
export const upgradeNewSLT3Finished = createSelector(getState, state => state.get('sltSlt3bUpgradeFinished'));
export const upgradeRouteState = createSelector(getState, state => state.get('sltSlt3bUpgradeRouteState'));



// WEBPACK FOOTER //
// ./src/core/state/install-upgrade-thermostat/slt3-slt3b/selectors.js